import { doc, setDoc, getDoc, collection, getDocs, updateDoc, deleteDoc } from 'firebase/firestore';
import { db } from './config';

// Platform token kaydet
export const savePlatformToken = async (userId, platformId, token, username = null) => {
  try {
    await setDoc(doc(db, 'users', userId, 'platforms', platformId), {
      enabled: true,
      token: token,
      username: username,
      connectedAt: new Date().toISOString()
    }, { merge: true });
    
    return { success: true };
  } catch (error) {
    console.error('Token kaydetme hatası:', error);
    return { success: false, error: error.message };
  }
};

// Platform token oku
export const getPlatformToken = async (userId, platformId) => {
  try {
    const docRef = doc(db, 'users', userId, 'platforms', platformId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { success: true, data: docSnap.data() };
    }
    return { success: true, data: null };
  } catch (error) {
    console.error('Token okuma hatası:', error);
    return { success: false, error: error.message };
  }
};

// Tüm platformları getir
export const getAllPlatforms = async (userId) => {
  try {
    const platformsRef = collection(db, 'users', userId, 'platforms');
    const snapshot = await getDocs(platformsRef);
    
    const platforms = [];
    snapshot.forEach(doc => {
      platforms.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return { success: true, data: platforms };
  } catch (error) {
    console.error('Platform listesi hatası:', error);
    return { success: false, error: error.message, data: [] };
  }
};

// Platform bağlantısını kes
export const disconnectPlatform = async (userId, platformId) => {
  try {
    await updateDoc(doc(db, 'users', userId, 'platforms', platformId), {
      enabled: false,
      token: null,
      disconnectedAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    console.error('Bağlantı kesme hatası:', error);
    return { success: false, error: error.message };
  }
};

// Platform sil
export const deletePlatform = async (userId, platformId) => {
  try {
    await deleteDoc(doc(db, 'users', userId, 'platforms', platformId));
    return { success: true };
  } catch (error) {
    console.error('Platform silme hatası:', error);
    return { success: false, error: error.message };
  }
};

// Post kaydet (taslak veya history için)
export const savePost = async (userId, postData) => {
  try {
    const postRef = doc(collection(db, 'users', userId, 'posts'));
    await setDoc(postRef, {
      ...postData,
      createdAt: new Date().toISOString()
    });
    
    return { success: true, postId: postRef.id };
  } catch (error) {
    console.error('Post kaydetme hatası:', error);
    return { success: false, error: error.message };
  }
};

// Kullanıcının postlarını getir
export const getUserPosts = async (userId, limit = 20) => {
  try {
    const postsRef = collection(db, 'users', userId, 'posts');
    const snapshot = await getDocs(postsRef);
    
    const posts = [];
    snapshot.forEach(doc => {
      posts.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    // Tarihe göre sırala (en yeni önce)
    posts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    
    return { success: true, data: posts.slice(0, limit) };
  } catch (error) {
    console.error('Post listesi hatası:', error);
    return { success: false, error: error.message, data: [] };
  }
};